import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import Consent from "./components/Consent";
import Home from "./components/Home";
import RegisterPhone from "./components/RegisterPhone";
import Scan from "./components/Scan";
import VerifyScan from "./components/VerifyScan";
import Profile from "./components/Profile";
import LogPanel from "./components/LogPanel";
import deviceDataFun from "./utils/DeviceData.js";

// import Profile from "./components/Profile";
import { LogProvider } from "./context/LogContext";


import "./styles.css";

const ProtectedRoute = ({ children }) => {
  const user = localStorage.getItem("userData");
  return user ? children : <Navigate to="/" />;
};

// 1. Consent Guard: Ensures that Consent has been accepted
const ConsentGuard = ({ children }) => {
  const consent = sessionStorage.getItem("consentAccepted");
  if (!consent) return <Navigate to="/consent" />;
  return children;
};

// 2. Scan Guard: Ensures that /scan is accessed only through a valid flow
const ScanGuard = ({ children }) => {
  const consent = sessionStorage.getItem("consentAccepted");
  const canScan = sessionStorage.getItem("canAccessScan");

  if (!consent) return <Navigate to="/consent" />;
  if (!canScan) return <Navigate to="/" />;
  return children;
};


const App = () => {
  const deviceData = deviceDataFun();
  const [screenWidth, setScreenWidth] = useState(() => window.innerWidth);

  useEffect(() => {
    const onResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isMobileView = screenWidth <= 900 || deviceData.deviceName === "Mobile";
  return (
    <LogProvider enabled={!isMobileView}>
      <BrowserRouter>
        <div className={`main-layout ${isMobileView ? "is-mobile" : ""}`}>
          <div className="left-section">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/consent" element={<Consent />} />

              {/* Protected routes that require Consent */}
              <Route path="/verify-phone" element={<ConsentGuard><RegisterPhone /></ConsentGuard>} />
              <Route path="/register" element={<ConsentGuard><Register /></ConsentGuard>} />
              <Route path="/verify-scan" element={<ConsentGuard><VerifyScan /></ConsentGuard>} />

              {/* /scan only opens if redirected from /register or Home */}
              <Route path="/scan" element={<ScanGuard><Scan /></ScanGuard>} />

              <Route path="/login" element={<Login />} />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
          </div>
          {!isMobileView && (
            <div className="right-section">
              <LogPanel />
            </div>
          )}
        </div>
      </BrowserRouter>
    </LogProvider>
  );
};

export default App;
